import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { createURL } from '@sm/utils';
import { Button as WrenchButton } from '@wds/button';
import { StaticContext, Recaptcha, useRecaptcha } from '@sm/webassets';
import classnames from 'classnames';

import { Button, Checkbox, Col, Container, FormField, Grid, Row, Typography } from '@sm/wds-react';
import './hero-form-cta.scss';

const HeroFormCTA = ({
  className,
  ctaFormEmail,
  ctaFormNewsletterOptOut,
  ctaFormPassword,
  ctaFormPrivacyConsent,
  ctaFormSubmit,
  ctaFacebook,
  ctaGoogle,
  disclaimer,
  utSource,
  utSource2,
}) => {
  const {
    environment: { countryCode },
  } = useContext(StaticContext);

  const containerClasses = classnames('sm-hero-form-cta', className);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleEmailChange = e => {
    setEmail(e.target.value);
  };
  const handlePasswordChange = e => {
    setPassword(e.target.value);
  };

  const submitCallback = () => {
    document.getElementById('signup_form').submit();
  };

  const recaptchaContext = useRecaptcha({
    actionName: 'user_signup',
    successCallback: submitCallback,
  });

  return (
    <Container pt={7} className={containerClasses} data-testid="HeroFormCTA">
      <form
        id="signup_form"
        method="post"
        action={createURL('/user/sign-up/', {
          ut_source: utSource,
          ut_source2: utSource2,
        })}
        data-testid="HeroFormCTA__Form"
      >
        <Recaptcha
          greToken={recaptchaContext.greToken}
          showError={recaptchaContext.showError}
          setShowError={recaptchaContext.setShowError}
        />
        <input type="hidden" name="username" className="input-username" value={email} />
        <input type="hidden" name="password_confirm" className="input-password_confirm" value={password} />
        <FormField>
          <label className="wds-label" htmlFor="email-input">
            {ctaFormEmail}
          </label>
          <input
            id="email-input"
            className="wds-input wds-input--md wds-input--stretched"
            type="email"
            name="email"
            required
            onChange={handleEmailChange}
          />
        </FormField>
        <FormField>
          <label className="wds-label" htmlFor="password-input">
            {ctaFormPassword}
          </label>
          <input
            id="password-input"
            className="wds-input wds-input--md wds-input--stretched"
            type="password"
            name="password"
            required
            onChange={handlePasswordChange}
          />
        </FormField>
        <Choose>
          <When condition={countryCode.toLowerCase() === 'de'}>
            <FormField>
              <Checkbox label={ctaFormPrivacyConsent} id="privacy-consents" name="privacy-consents" required />
            </FormField>
            <FormField>
              <Checkbox label={ctaFormNewsletterOptOut} id="subscribe-to-newsletter" name="subscribe-to-newsletter" />
            </FormField>
          </When>
        </Choose>
        <WrenchButton size="lg" align="center" stretched mt={5} onClick={recaptchaContext.fireGRE}>
          {ctaFormSubmit}
        </WrenchButton>
      </form>
      <Container mb={4} mt={4} className="sm-hero-form-cta__hardrule" />
      <Grid noBleeds>
        <Row>
          <Col xs={6}>
            {/* @todo: We will need to connect with Henry W to discuss how to convert this over */}
            <Button
              stretched
              className="sm-hero-form-cta__fb-button wds-button--text"
              href={createURL('/user/third-party/', {
                third_party: 'facebook',
                action: 'sign_up',
              })}
            >
              <span className="wds-m-l-4">{ctaFacebook}</span>
            </Button>
          </Col>
          <Col xs={6}>
            {/* @todo: We will need to connect with Henry W to discuss how to convert this over */}
            <Button
              stretched
              className="sm-hero-form-cta__g-button wds-button--text"
              href={createURL('/user/third-party/', {
                third_party: 'google',
                action: 'sign_up',
              })}
            >
              <span className="wds-m-l-4">{ctaGoogle}</span>
            </Button>
          </Col>
        </Row>
      </Grid>
      <Typography
        align="center"
        component="div"
        variant="bodySm"
        color="dark-muted"
        className="wds-m-t-3"
        dangerouslySetInnerHTML={{ __html: `${disclaimer}` }} // eslint-disable-line jam3/no-sanitizer-with-danger
      />
    </Container>
  );
};

HeroFormCTA.propTypes = {
  className: PropTypes.string.isRequired,
  ctaFormSubmit: PropTypes.string.isRequired,
  ctaFormEmail: PropTypes.string.isRequired,
  ctaFormNewsletterOptOut: PropTypes.string.isRequired,
  ctaFormPassword: PropTypes.string.isRequired,
  ctaFormPrivacyConsent: PropTypes.node.isRequired,
  ctaFacebook: PropTypes.string,
  ctaGoogle: PropTypes.string,
  disclaimer: PropTypes.string.isRequired,
  utSource: PropTypes.string,
  utSource2: PropTypes.string,
};

HeroFormCTA.defaultProps = {
  ctaFacebook: 'FACEBOOK',
  ctaGoogle: 'GOOGLE',
  utSource: '',
  utSource2: '',
};

export default HeroFormCTA;
